import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { showError, showSuccess } from '../../utils/sweetAlertConfig';

const ExportExcel = ({
  data = [],
  headers = [],
  fileName = '',
  textButton = '',
  className = '',
  width = 'auto' }) => {

  const handleExport = () => {
    if (!data.length) {
      showError('ผิดพลาด', 'ไม่มีข้อมูลสำหรับส่งออก');
      return;
    }

    // แปลงข้อมูลเป็นรูปแบบที่ Excel เข้าใจ
    const wsData = [
      headers.map(h => h.label || h), // แถว header
      ...data.map(row =>
        headers.map(h => row[h.key] ?? '') // แถวข้อมูล
      )
    ];

    // สร้าง worksheet และ workbook
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // ตั้งค่าความกว้างของ column
    if (width !== 'auto') {
      ws['!cols'] = headers.map(() => ({ wpx: width }));
    }

    // เขียนไฟล์เป็น blob
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName === '' ? 'export' : fileName);

    showSuccess('สำเร็จ', 'ไฟล์ได้ถูกดาวน์โหลดแล้ว');
  };

  return (
    <button onClick={handleExport} className={`px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 font-medium transition-colors `+className}>
      { textButton === '' ? 'ส่งออก (Excel)': textButton }
    </button>
  );
};

export default ExportExcel;
